<template>
  <div style="margin: 0 8px 8px;">
    <el-form ref="formRef" :model="projectForm" label-width="104px" label-position="right">
      <el-form-item label="项目类型：">
        <el-radio-group v-model="projectType" @change="projectTypeChange" :disabled="projectForm.state > 0">
          <el-radio :label="1">系统项目</el-radio>
          <el-radio :label="2">邀请奖励项目</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="服务类型：">
        <el-select v-model="serviceType" placeholder="Select" style="width: 22em" :disabled="type == 2" @change="serviceTypeChange">
          <el-option v-for="item in (projectType == 1?serviceTypeList:serviceTypeListPrize)" :key="item.serviceType" :label="item.name" :value="item.serviceType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称：">
        <el-input v-model="projectForm.name" placeholder="请输入项目名称" style="width: 22em" />
      </el-form-item>
      <el-form-item label="类型：">
        <el-radio-group v-model="type" @change="typeChange" :disabled="projectType == 2">
          <el-radio :label="1">金额</el-radio>
          <el-radio :label="2" :disabled="serviceType == 10">张数</el-radio>
          <el-radio :label="3" :disabled="serviceType == 10">次数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否回访：">
        <el-radio-group v-model="visitType" @change="visitTypeChange">
          <el-radio :label="1">无需回访</el-radio>
          <el-radio :label="2">立即回访</el-radio>
          <el-radio :label="3">回访天数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="回访天数：" v-if="visitType == 3">
        <el-input v-model="projectForm.visitDay" placeholder="请输入数值" style="width: 22em" />
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="projectForm.orderNum" placeholder="数值越大越靠前" style="width: 22em" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateProject, getSysPositionList } from "@/api/url";
import {greaterIntReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      projectForm: this.value.projectForm,
      type: this.value.projectForm.type?this.value.projectForm.type:1,
      idx: this.value.ids,

      serviceTypeList: this.value.serviceTypeList,
      serviceTypeListPrize: this.value.serviceTypeList.filter(item => item.serviceType == 1 || item.serviceType == 2 || item.serviceType == 5),
      serviceType: this.value.projectForm.projectService?this.value.projectForm.projectService.serviceType:1,
      projectType: this.value.projectForm.projectType?this.value.projectForm.projectType:1,

      visitType: this.value.projectForm.visitDay == -1?1:this.value.projectForm.visitDay == 0?2:this.value.projectForm.visitDay > 0?3:1,
    }
  },
  methods: {

    serviceTypeChange(val) {
      if(val == 6) {
        this.type = 3
      }
      if(val == 10) {
        this.type = 1
      }
    },

    typeChange(val) {
      console.log(val)
      if(val == 2) {
        this.serviceType = 1
      }
      if(val == 3) {
        this.serviceType = 6
      }
    },

    projectTypeChange(val) {
      if(val == 2) {
        this.type = 1
        this.serviceType = 1
      }
    },

    visitTypeChange(val) {
      if(val == 3){
        this.projectForm.visitDay = ''
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      // console.log(this.idx)
      if(!this.projectForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '项目名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.visitType == 3 && !greaterIntReg.test(this.projectForm.visitDay)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的回访天数',
          type: 'warning'
        });
        return false
      }
      if(!this.projectForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.projectForm.id:0;
      param['name'] = this.projectForm.name;
      param['orderNum'] = this.projectForm.orderNum;
      param['type'] = this.type;
      param['serviceType'] = this.serviceType;
      param['projectType'] = this.projectType;
      param['visitDay'] = this.visitType == 1?-1:this.visitType == 2?0:this.projectForm.visitDay
      postFormData(addOrUpdateProject, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getPositionList() {
      getFormData(getSysPositionList).then(data=> {
        this.positionTypeArray = data.data
      })
    },



  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
